import styles from "./Face1.module.scss";

export default function Face1() {
  const url = `${process.env.PUBLIC_URL}/images/23Somethinglightweight.jpg`;

  return (
    <div className={styles.card} style={{ backgroundImage: `url("${url}")` }} />
  );
}
